<template>
  <div class="notifications-stack">
    <VSnackbar
      v-for="notification in notifications"
      :key="notification.id"
      :model-value="true"
      :timeout="notification.timeout ?? 5000"
      :color="colorMap(notification.type)"
      location="top end"
      variant="flat"
      stacked
      class="mb-2"
      @timeout="removeNotification(notification.id)"
    >
      {{ notification.message }}
      <template #actions>
        <VBtn
          variant="text"
          color="white"
          size="small"
          @click="removeNotification(notification.id)"
        >
          Fermer
        </VBtn>
      </template>
    </VSnackbar>
  </div>
</template>

<script setup lang="ts">
/**
 * @component NotificationsManager
 * @description Renders queued notifications (store) as Vuetify snackbars.
 */
import { computed } from 'vue'
import { VSnackbar, VBtn } from 'vuetify/components'
import { useNotificationStore } from '@/stores/notificationStore'

const notificationStore = useNotificationStore()

const notifications = computed(() => notificationStore.notifications)

const removeNotification = (id: number) => {
  notificationStore.removeNotification(id)
}

const colorMap = (type: string) => {
  if (type === 'error') return 'error'
  if (type === 'warning') return 'warning'
  if (type === 'success') return 'success'
  return 'info'
}
</script>

<style scoped>
.notifications-stack {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 2000;
  max-width: 360px;
}
</style>
